export function imageDimensions (imageObjectURL) {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.src = imageObjectURL

    img.onload = () => {
      const { naturalWidth: width, naturalHeight: height } = img
      resolve({ width, height })
    }

    img.onerror = () => {
      reject(new Error('There is something wrong with this image'))
    }
  })
}
